export class SamplePrintTemplate {

    sampleObjectId: string;
    plateOrTube: string;

}